import Stock from "../model/DashboardStock";

export const SetStocks = (stocks:Stock[]) => {
    return {
        type: 'SET_STOCKS',
        value: stocks
    }
}